// Pure logic of the lead receipt view (spec 2026-10-18-lead-receipts §9). Kept out of the component so the
// Vue 3 admin can reuse it as is.

export const CHANNELS = ['crm_plugin', 'owner_mail', 'webhook', 'confirm_mail', 'follow_up_mail'];

const RANK = { sent: 0, pending: 1, failed: 2 };

/** One chip per channel that has deliveries, in fixed order; a channel shows its worst status. */
export function channelSummary(lead) {
  const deliveries = (lead && lead.deliveries) || [];
  return CHANNELS
    .map((channel) => {
      const own = deliveries.filter((d) => d.channel === channel);
      if (!own.length) return null;
      const status = own.reduce((worst, d) => (RANK[d.status] > RANK[worst] ? d.status : worst), 'sent');
      return {
        channel, status, total: own.length, sent: own.filter((d) => d.status === 'sent').length,
      };
    })
    .filter(Boolean);
}

const ICONS = { sent: 'check-circle-fill', pending: 'clock', failed: 'exclamation-triangle-fill' };

export function statusIcon(status) {
  return ICONS[status] || 'question-circle';
}

export function canResend(delivery) {
  // Pending rows retry by themselves, may be mid-attempt, or are a follow-up waiting for 09:00.
  return !!delivery && delivery.status === 'failed';
}

/** A webhook secret made in the browser; the server stores it and never sends it back. */
export function generateSecret(cryptoObj) {
  const bytes = cryptoObj.getRandomValues(new Uint8Array(32));
  return `whsec_${Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')}`;
}

export function consentBlocksOf(formDoc) {
  if (!formDoc || !Array.isArray(formDoc.pages)) return [];
  const lang = formDoc.defaultLanguage;
  return formDoc.pages
    .flatMap((p) => p.blocks || [])
    .filter((b) => b.type === 'consent')
    .map((b) => ({ id: b.id, label: (b.label && (b.label[lang] || Object.values(b.label)[0])) || b.id }));
}

/** Locale key under settings.forms.leads.source: 'form' or the plugin name of a mirrored lead gate. */
export function sourceKey(lead) {
  const source = (lead && lead.source) || 'form';
  return source.indexOf('plugin:') === 0 ? source.slice('plugin:'.length) : 'form';
}
